import React from 'react';
import { Tag, Typography } from 'antd';
import colors from '../../utils/theme/colors';

const { Text } = Typography;

export default function ApiEndpointBadge({ method, path }) {
  const methodColor = method === 'POST' ? '#3b82f6' : '#10b981';
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        background: colors.muted,
        padding: '6px 12px',
        borderRadius: 8,
        border: `1px solid ${colors.border}`,
      }}
    >
      <Tag color={methodColor} style={{ margin: 0, fontWeight: 700, fontSize: 11 }}>
        {method}
      </Tag>
      <Text code style={{ color: colors.foreground, fontSize: 13 }}>
        https://client-api.fluxuro.ai{path}
      </Text>
    </div>
  );
}
